import type { UserRole } from "@/api/auth";
import { canOpenQuoteSettings } from "@/utils/quoteSettingsRoles";

export type QuoteSettingsSection =
  | "rates"
  | "policy"
  | "catalogs"
  | "calibration";

export const QUOTE_SETTINGS_PATHS: Record<QuoteSettingsSection, string> = {
  rates: "/app/quickquote/settings/rates",
  policy: "/app/quickquote/settings/policy",
  catalogs: "/app/quickquote/settings/catalogs",
  calibration: "/app/quickquote/settings/calibration",
};

export const QUOTE_SETTINGS_LABELS: Record<QuoteSettingsSection, string> = {
  rates: "机时费与费率卡",
  policy: "报价政策与默认值",
  catalogs: "报价目录",
  calibration: "本厂标定",
};

/** 前两区原GET全登录可读；后两区保留既有四角色守卫。 */
export function visibleQuoteSettingsSections(
  role?: UserRole | null,
): QuoteSettingsSection[] {
  if (!role) return [];
  return canOpenQuoteSettings(role)
    ? ["rates", "policy", "catalogs", "calibration"]
    : ["rates", "policy"];
}
